<sz-card variant="featured">
  <div class="session-best">
    @if (focal(); as f) {
      <div class="session-best__label">{{ f.label }}</div>
      <sz-num-focal [value]="f.value" [unit]="f.unit" size="xl" />
    }
    @if (tiles().length > 0) {
      <div class="session-best__tiles">
        @for (tile of tiles(); track tile.label) {
          <sz-tile [label]="tile.label" [value]="tile.value" [unit]="tile.unit" [variant]="tile.variant" />
        }
      </div>
    }
  </div>
</sz-card>
